function GlobalDesignedCheckbox({ label, checked, onChange, name }) {
	const labelStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		cursor: 'pointer',
		fontSize: '14px'
	};

	const inputStyle = {
		width: '14px',
		height: '14px',
		cursor: 'pointer',
		border: '1px solid #ccc',
		borderRadius: '2px',
		accentColor: '#B50072',
		marginLeft: '8px'
	};

	return (
		<label style={labelStyle}>
			<input
				type="checkbox"
				checked={checked}
				onChange={onChange}
				name={name}
				style={inputStyle}
			/>
			<span>{label}</span>
		</label>
	);
}

export default GlobalDesignedCheckbox;
